import { ProtocolPdfDto } from 'src/app/dtos/protocolPdfDto';
import { InspectionWithResultsDto } from '@core/api';
import { ProtocolPdfZhService } from './protocol-pdf-zh.service';
import { ProtocolPdfConstants } from './protocol-pdf.constants';
import { ProtocolDto } from 'src/app/dtos/protocolDto';
import { ProtocolPdfResultDto } from 'src/app/dtos/ProtocolPdfResultDto';

export class ProtocolPdfZhPaincausingProceduresService extends ProtocolPdfZhService {
  protected getInspectionHeaderSecondColumnTexts(
    inspection: InspectionWithResultsDto,
    extendedVersion: boolean,
    protocol: ProtocolDto,
  ): Map<string, string> {
    const columnTexts = new Map<string, string>();
    columnTexts.set(
      this.translateService.instant('ProtocolPdf.LabelBURNr'),
      inspection.unitBurId ?? '',
    );
    if (extendedVersion) {
      columnTexts.set(
        this.translateService.instant('ProtocolPdf.LabelPhone'),
        inspection.unitWorkPhones ?? '',
      );
    }
    columnTexts.set(
      this.translateService.instant('ProtocolPdf.LabelDate'),
      this.getInspectionDate(inspection),
    );
    columnTexts.set(
      this.translateService.instant('ProtocolPdf.LabelDuration'),
      this.getInspectionDuration(protocol),
    );
    columnTexts.set(
      this.translateService.instant('ProtocolPdf.LabelType'),
      this.getInspectionStyleName(inspection),
    );
    return columnTexts;
  }

  protected getProtocolFileName(protocolPdfDto: ProtocolPdfDto): string {
    return `kontrolle-${protocolPdfDto.inspection.inspectionId}-tieraerztliche-privatapotheken.pdf`;
  }

  protected addSpaceBetweenResultsAndCheckboxes(_size: number, baseY: number): number {
    baseY += ProtocolPdfConstants.lineHeight;
    return baseY;
  }

  protected addDocumentationCheckboxes(baseY: number): number {
    return baseY;
  }

  protected addSignatureBlock(protocolPdfDto: ProtocolPdfDto, baseY: number): number {
    baseY = this.addSignatureDate(baseY, protocolPdfDto.inspection);
    return this.addSignaturePersons(baseY);
  }

  protected getTextOptionFurtherProcedureDetails1(): string {
    return this.translateService.instant(
      `ProtocolPdf.TextOptionFurtherProcedureDetailsPrivatePharmaciesZh1`,
    );
  }

  protected getTextOptionFurtherProcedureDetails2(): string {
    return this.translateService.instant(
      `ProtocolPdf.TextOptionFurtherProcedureDetailsPrivatePharmaciesZh2`,
    );
  }

  protected getTextOptionFurtherProcedureDetails3(): string {
    return this.translateService.instant(
      `ProtocolPdf.TextOptionFurtherProcedureDetailsPrivatePharmaciesZh3`,
    );
  }

  protected getTextOptionFurtherProcedureDetails4(): string {
    return this.translateService.instant(
      `ProtocolPdf.TextOptionFurtherProcedureDetailsPrivatePharmaciesZh4`,
    );
  }

  protected getInspectionPersonTranslationKey(): string {
    return this.translateService.instant(
      'ProtocolPdf.LabelSignatureInspectionPersonTitlePrivatePharmaciesZh',
    );
  }

  protected getInspectionResponsiblePersonTranslationKey(): string {
    return this.translateService.instant('ProtocolPdf.LabelSignatureControlledPerson');
  }

  protected addFurtherProcedureDetailsAbbreviations(baseY: number): number {
    return baseY;
  }

  protected getPointNumber(defect: ProtocolPdfResultDto): string {
    const groupElementText = defect.groupElementNumber ? `${defect.groupElementNumber}- ` : '';
    return `${groupElementText}${defect.pointNumber}`;
  }
}
